import React, { useContext } from 'react'
import { delay } from 'lodash'
import { Box } from '@hub/box'
import { CoreContainer } from '@hub/core-container'
import { useToken } from '@hub/design-system-base'
import { LinkContext } from '../../../context'
import { LinkItem } from '../types'
import { MainNavItemWrapper } from './main-nav-item-wrapper'

export const SimpleMenu: React.FC<{
  itemId: string
  index: number
  menuItems?: LinkItem[]
  liComponentRef?: HTMLLIElement | null
  megamenuFocusRef?: React.MutableRefObject<boolean>
}> = ({ itemId, index, menuItems, megamenuFocusRef, liComponentRef }) => {
  const leftPadding = useToken(
    'space',
    index === 0 ? 'spacing-md' : 'spacing-sm'
  )
  const Link = useContext(LinkContext)
  const left = liComponentRef
    ? liComponentRef?.getBoundingClientRect().x - parseInt(leftPadding)
    : 0

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '100%',
        zIndex: 'dropdown',
        left,
      }}
      role="none"
      ref={(box: HTMLElement) => {
        if (box && megamenuFocusRef?.current) {
          const DELAY_FOR_MAKING_SURE_FOCUS_IS_POSSIBLE = 50
          delay(
            () => box.querySelector('a')?.focus(),
            DELAY_FOR_MAKING_SURE_FOCUS_IS_POSSIBLE
          )
          megamenuFocusRef.current = false
        }
      }}
    >
      <CoreContainer
        as="ul"
        tabIndex={-1}
        id={itemId}
        sx={{
          fontSize: 'font-sm',
          paddingY: 'spacing-md',
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          alignContent: 'space-between',
          minWidth: 'size-md',
          marginTop: '1px',
          backgroundColor: 'white',
        }}
        gutter={'spacing-md'}
      >
        {menuItems &&
          menuItems.map((menuItem, i) => (
            <MainNavItemWrapper
              key={`${menuItem.url}-${menuItem.label}`}
              sx={{ paddingTop: 'spacing-xs' }}
            >
              <Link
                to={menuItem.url}
                component={({ children, ...props }) => (
                  <a {...props}>{children}</a>
                )}
                id={`megamenu-item-${i}`}
              >
                {menuItem.label}
              </Link>
            </MainNavItemWrapper>
          ))}
      </CoreContainer>
    </Box>
  )
}
